import { RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import cn from 'classnames';

import styles from './index.module.css';

export interface UpDownProps {
  value: 'asc' | 'desc' | undefined;
  onChange: (value: 'asc' | 'desc' | undefined) => void;
  block?: boolean;
  labels?: [string, string];
}

const getTextButton = (value: UpDownProps['value'], labels: UpDownProps['labels']) => {
  switch (value) {
    case 'asc':
      return labels ? labels[0] : 'По возрастанию';
    case 'desc':
      return labels ? labels[1] : 'По убыванию';

    default:
      return 'Направление';
  }
};

export default function UpDown({ value, onChange, block, labels }: UpDownProps) {
  const handleChangeDirection = () => {
    switch (value) {
      case 'asc':
        onChange('desc');
        break;
      case 'desc':
        onChange('asc');
        break;

      default:
        break;
    }
  };
  return (
    <Button
      id="offer-sort-direction"
      disabled={!value}
      icon={<RightOutlined />}
      onClick={handleChangeDirection}
      className={cn(styles.default, { [styles.up]: value === 'asc', [styles.down]: value === 'desc' })}
      block={block}
    >
      {getTextButton(value, labels)}
    </Button>
  );
}
